import './assets/Carousel.css';const _ = "_carousel_60lzn_1", l = "_carousel__scroller_60lzn_11", o = {
  carousel: _,
  carousel__scroller: l,
  "carousel-controls": "_carousel-controls_60lzn_38",
  "carousel-controls__btn": "_carousel-controls__btn_60lzn_42",
  "carousel-controls__previous": "_carousel-controls__previous_60lzn_67",
  "carousel-controls__next": "_carousel-controls__next_60lzn_74",
  "carousel-nav": "_carousel-nav_60lzn_86",
  "carousel-nav__list": "_carousel-nav__list_60lzn_90",
  "carousel-nav__item": "_carousel-nav__item_60lzn_99"
};
export {
  o as c
};
